import { request } from "@/components/Joyspace/api/request";

// 查询是否可以创建知识库权限
export function canCreateWiki() {
  return request({
    api: "joyspace.permission.loginUser",
    path: `/v1/permissions/loginUser`,
    method: "GET"
  });
}

// 创建知识库
export function createWiki(props: {
  name: string;
  parent: string;
  description?: string;
  icon?: string;
}) {
  return request({
    api: "joyspace.folder.create",
    path: `/v1/folders`,
    method: "POST",
    body: props
  });
}

// 上传知识库图标
export function uploadIcon(formData: any) {
  return request({
    api: "joyspace.file.ossUpload",
    path: `/v1/files/upload`,
    method: "POST",
    body: formData
  });
}
